// import router from "router";
// import JwtService from "core/services/jwt.service";
import Vue from "vue";
import { ir } from "./check_domain_ir";
import JwtService from "./core/plugins/TitleRibbon/assets/js/jwt.service";
import router from "./router";
import { LOGOUT } from "@/core/services/store/auth.module";
import store from "@/core/services/store";
import { mapGetters } from "vuex";
import { VueReCaptcha } from "vue-recaptcha-v3";
import ax from "./axiosMeth.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import moment from "moment-jalaali";
import axiosApi from "axios";

let coreland = process.env.VUE_APP_CoreLandUrl;
let payamakland = process.env.VUE_APP_PayamakLandURL;
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA3_SITE });

let id_token = localStorage.getItem("id_token");
const axios = axiosApi.create({
  baseURL: Vue.prototype.$qrApi,
  timeout: 15000,
  headers: {
    Authorization: !!id_token ? "Bearer " + id_token : undefined,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});
Vue.prototype.$qr_api = axios;

const Mixin = {
  mounted() {
    $("input[name='table-search']")
      .parent()
      .removeClass("offset-md-6")
      .addClass("ms-auto");
    // this.getSpecialmenu();
    // start filters
    Vue.filter("currency", (x) => {
      return x
        ? new Intl.NumberFormat("en-US", { style: "decimal" }).format(x)
        : "-";
    });

    Vue.filter("timeAgo", (value) => moment(value).fromNow());

    Vue.filter("longDate", (value) =>
      moment(value).format("HH:mm jYYYY-jM-jD")
    );

    Vue.filter("rial", (value) =>
      value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    );

    Vue.filter("stringDate", function (input) {
      try {
        // let moment = require('moment-jalaali')
        moment.locale("fa", null);
        moment.loadPersian({ dialect: "persian-modern" });
        return moment(input, "YYYY-M-D HH:mm:ss").format("dddd LL HH:mm:ss");
      } catch (e) {}
    });

    Vue.filter("persianNum", function (input) {
      try {
        if (input === undefined || input == null) return "";
        let str1 = input.toString().trim();
        if (str1 === "") return "";
        str1 = str1.replace(/0/gim, "۰");
        str1 = str1.replace(/1/gim, "۱");
        str1 = str1.replace(/2/gim, "۲");
        str1 = str1.replace(/3/gim, "۳");
        str1 = str1.replace(/4/gim, "۴");
        str1 = str1.replace(/5/gim, "۵");
        str1 = str1.replace(/6/gim, "۶");
        str1 = str1.replace(/7/gim, "۷");
        str1 = str1.replace(/8/gim, "۸");
        str1 = str1.replace(/9/gim, "۹");
        return str1;
      } catch (e) {}
    });

    Vue.filter("userType", (value) => {
      if (value === "legal") return "شخص حقوقی";
      return "شخص حقیقی";
    });

    Vue.filter("isEmpty", (val) => {
      return val ? val : "";
    });

    Vue.filter("serviceType", (val) => {
      if (val === "Payamakland") return "پیامک لند";
      else if (val === "Coreland") return "کورلند";
      else if (val === "Qrland") return "کیوآر لند";
      else if (val === "Robotland") return "ربات لند";
      else if (val === "billboard") return "بیلبورد";
      else if (val === "tablighNegar") return "تبلیغ نگار";
      else return "نامعلوم";
    });

    Vue.filter("qrType", function (val, key) {
      let types = [
        { value: "instagram", name: "اینستاگرام", icon: "instagram" },
        {
          value: "visitCard",
          name: "کارت ویزیت",
          icon: "card-account-details",
        },
        { value: "Business", name: "کسب و کار", icon: "store" },
        { value: "bShop", name: "صفحه فروشگاهی", icon: "storefront" },
        {
          value: "SocialMedia",
          name: "شبکه های اجتماعی",
          icon: "comment-account",
        },
        { value: "VideoGallery", name: "گالری فیلم", icon: "video" },
        { value: "PhotoGallery", name: "گالری عکس", icon: "image" },
        { value: "singleProduct", name: "معرفی محصول", icon: "package" },
        { value: "menu", name: "منو", icon: "book-open-outline" },
        { value: "appointment", name: "نوبت دهی", icon: "calendar-month" },
      ];

      try {
        return types.find(
          (item) => item.value.toLowerCase() === val.toLowerCase()
        )[key];
      } catch (e) {
        return {
          value: "instagram",
          title: "اینستاگرام",
          icon: "instagram",
        }[key];
      }
    });

    Vue.filter("expireColor", (exp) => {
      if (typeof exp === "number") {
        if (exp > 30) return "";
        else if (exp <= 30 && exp > 15) return "in-month";
        else if (exp <= 15 && exp >= 1) return "in-days";
        else return "in-expire";
      } else return "in-expire";
    });

    Vue.filter("untilExpire", (exp) => {
      return this.getUntilExpire(exp);
    });

    Vue.filter("typeText", (time, text = true) => {
      return this.getTypeText(time, text);
    });

    Vue.filter("persianNumber", (value) => {
      return value.toPersianLetter();
    });

    Vue.filter("numericPersianNumber", (value) => {
      if (value < 1_000_000) return value / 1_000 + " هزار";
      return value / 1_000_000 + " میلیون";
    });

    Vue.filter("getProductImage", (item) => {
      try {
        if (!!item)
          if (typeof item === "string") {
            let obj = JSON.parse(item);
            return obj?.[0]?.images[0]?.url || "";
          }
      } catch (e) {
        console.log(e);
      }

      return "";
    });
    // end filters
  },
  methods: {
    ...ax,
    datediff(first, second) {
      return Math.round((second - first) / (1000 * 60 * 60 * 24));
    },
    async generateRecaptchaToken(action) {
      await this.$recaptchaLoaded();
      return await this.$recaptcha(action);
    },
    coreLandApi(url) {
      return coreland + `/storage/${url}`;
    },
    toggleNavigation() {
      this.$store.dispatch("menu/toggle");
    },
    toggleMobileMenu() {
      this.$store.dispatch("menu/toggle");
      // this.$store.dispatch('menu/toggleMobile');
    },
    cloneObject(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    firstLetter(input) {
      if (!input) return "U";
      return input.charAt(0).toUpperCase().toString();
    },
    fixLink(link) {
      return link?.startsWith("http") ? link : "https://" + link;
    },
    getTypeText(time, text = true) {
      if (typeof time === "number") {
        return text ? this.persian(time) + " روز" : "روز";
        // return text ? this.persian(time) + ' روز تا انقضا' : 'روز تا انقضا'
      } else if (time === "expired") return "منقضی شده";
    },
    getUntilExpire(exp) {
      let moment = require("moment-jalaali");
      let diff = moment(exp).diff(new Date(), "days");

      if (diff > 0) {
        return diff;
      } else return "expired";
    },
    logout() {
      this.$toast.warning("لطفا وارد شوید");
      return this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    getTime: function (input) {
      try {
        let time = input.split(" ")[1].split(":");
        return time[0] + ":" + time[1];
      } catch (e) {
        return input;
      }
    },
    jalalian: function (input, type = "date", sp = "/") {
      try {
        let moment = require("moment-jalaali");
        let date = moment(
          input,
          type === "date" ? `YYYY${sp}MM${sp}DD` : `YYYY${sp}MM${sp}DD HH:mm:ss`
        );
        return date.format(
          type === "date"
            ? `jYYYY${sp}jMM${sp}jDD`
            : `jYYYY${sp}jMM${sp}jDD HH:mm:ss`
        );
      } catch (e) {
        console.log("jalali error: ", e);
        return input;
      }
    },
    datetime(input, type) {
      if (!input || !input.length) return "-";

      if (type === "datetime") {
        return `${this.jalalian(input)} ${this.getTime(input)}`;
      } else {
        return `${this.jalalian(input)}`;
      }
    },
    dateString(input) {
      try {
        let moment = require("moment-jalaali");
        moment.locale("fa", null);
        moment.loadPersian({ dialect: "persian-modern" });
        return (
          moment(input, "YYYY-M-D").format("dddd LL") +
          " ساعت " +
          moment(input).format("LT")
        );
      } catch (e) {}
    },
    dateDiffNow(input) {
      try {
        let moment = require("moment-jalaali");
        moment.locale("fa", null);
        moment.loadPersian({ dialect: "persian-modern" });
        return moment(input).fromNow();
      } catch (e) {
        return input;
      }
    },
    nowDateTimeString(sp = "-", type = "datetime") {
      let moment = require("moment-jalaali");
      let res = "";
      if (type === "date") {
        res = moment().format(`YYYY${sp}MM${sp}DD`);
      } else if (type === "time") {
        res = moment().format(`HH:mm:ss`);
      } else {
        res = moment().format(`YYYY${sp}MM${sp}DD HH:mm:ss`);
      }
      return res;
    },
    async checkTokenAsync(token) {
      try {
        let res = await axios.get(`${this.$sarveLand}/api/user`, {
          headers: {
            secret: process.env.VUE_APP_CoreSecret,
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.status === 200) {
          localStorage.setItem("user_info", JSON.stringify(res.data));
          this.$store.dispatch("setUser", res.data);
          // store.dispatch('setUser',JSON.stringify(res.data));
          // this.$router.push({name: 'dashboard'})
        }
      } catch (e) {
        if (e.response.status === 401) {
          this.$store
            .dispatch(LOGOUT)
            .then(() => window.location.replace(`${this.$sarveLandFront}`));
        }
      }
    },
    getWallet() {
      return JSON.parse(localStorage.getItem("user_wallet"));
    },
    checkWallet() {
      let walletInfo = "";
      axios
        .post(
          `${coreland + "/api"}/wallet`,
          {},
          {
            headers: this.header(),
          }
        )
        .then(({ data }) => {
          if (data.currency === "Rial") {
            walletInfo = this.changeMoney("rial");
          }
          if (data.currency === "Toman") {
            walletInfo = this.changeMoney("toman");
          }
          if (data.currency === "Dollar") {
            walletInfo = this.changeMoney("dollar");
          }
          if (data.currency === "Euro") {
            walletInfo = this.changeMoney("euro");
          }
          if (data.currency === "Bitcoin") {
            walletInfo = this.changeMoney("bitcoin");
          }
          if (data.currency === "Ethereum") {
            walletInfo = this.changeMoney("ethereum");
          }
          let user_wallet = {
            icon: walletInfo.icon,
            color: walletInfo.color,
            balance: data.balance,
          };
          localStorage.setItem("user_wallet", JSON.stringify(user_wallet));
          this.$store.dispatch("wallet/setWallet", user_wallet);
        })
        .catch(({ response }) => {
          if (response.status === 401) {
            this.logout();
          }
        });
    },
    changeMoney(data) {
      return {
        icon: money.data[data].icon,
        color: money.data[data].color,
        value: money.data[data].value,
      };
    },
    goto(route, query = {}) {
      router.push({ path: "/" + route, query: query });
    },
    goReplace(route) {
      router.replace({ path: "/" + route });
    },
    toggleNightMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.setCookie("theme", this.$vuetify.theme.dark, "60");
    },
    setCookie(cname, cvalue, exdays) {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname, def = "") {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return def;
    },
    header() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    },
    payamakHeader() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    },
    requestApiGet(uri, queries = {}) {
      return axios.get(`${coreland + "/api"}/${uri}`, {
        headers: this.header(),
        params: queries,
      });
    },
    requestApiGetPayamak(uri, queries = {}) {
      return axios.get(`${payamakland + "/api"}/${uri}`, {
        headers: this.payamakHeader(),
        params: queries,
      });
    },
    requestApiPostPayamak(uri, data = {}) {
      return axios.post(`${payamakland + "/api"}/${uri}`, data, {
        headers: this.payamakHeader(),
      });
    },
    requestApiPost(uri, data = {}) {
      return axios.post(`${coreland + "/api"}/${uri}`, data, {
        headers: this.header(),
      });
    },
    requestApiPostLogin(uri, data = {}) {
      return axios.post(`${coreland + "/api"}/${uri}`, data);
    },
    persian(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/0/gim, "۰");
      str1 = str1.replace(/1/gim, "۱");
      str1 = str1.replace(/2/gim, "۲");
      str1 = str1.replace(/3/gim, "۳");
      str1 = str1.replace(/4/gim, "۴");
      str1 = str1.replace(/5/gim, "۵");
      str1 = str1.replace(/6/gim, "۶");
      str1 = str1.replace(/7/gim, "۷");
      str1 = str1.replace(/8/gim, "۸");
      str1 = str1.replace(/9/gim, "۹");
      return str1;
    },
    setBreadcrumb(title) {
      this.$store.dispatch(SET_BREADCRUMB, [{ title }]);
    },
    english(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/۰/gim, "0");
      str1 = str1.replace(/۱/gim, "1");
      str1 = str1.replace(/۲/gim, "2");
      str1 = str1.replace(/۳/gim, "3");
      str1 = str1.replace(/۴/gim, "4");
      str1 = str1.replace(/۵/gim, "5");
      str1 = str1.replace(/۶/gim, "6");
      str1 = str1.replace(/۷/gim, "7");
      str1 = str1.replace(/۸/gim, "8");
      str1 = str1.replace(/۹/gim, "9");
      return str1;
    },
    price: function (input) {
      try {
        return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } catch (e) {
        return input;
      }
    },
    permissionStatus(permissionName) {
      this.requestApiPost("abilitiesStatus", { name: permissionName }).then(
        (response) => {
          if (response.data === "show") {
            // window.alert('شما به این بخش دسترسی ندارید!');
            return false;
          }
          // window.alert('done')
          return true;
          // return response.data
        }
      );
    },
  },
  computed: {
    ...mapGetters(["user"]),
    wallet() {
      return this.$store.getters["wallet/wallet"];
    },
  },
};

export { Mixin };

export default {
  install(Vue, options) {
    Vue.mixin(Mixin);
  },
};
